//Format Time with momentJS
import * as moment from 'moment'

export class PunchDataModel {
  BusinessDate: any = null;
  PunchIn: any = null;
  PunchOut: any = null;
  TotalMinutes: any = null;

  constructor(data) {
    this.BusinessDate = data.BusinessDate;
    this.PunchIn = data.PunchInForSubmit;
    this.PunchOut = data.PunchOutForSubmit;
    this.TotalMinutes = Math.abs(moment.duration(moment(data.PunchInForSubmit).diff(moment(data.PunchOutForSubmit))).asMinutes());
  }
}